import React, { useState } from 'react'
import {
  Select,
} from 'antd'
import {
  Div,
} from 'konsys-ui'
import {
  Label, Content,
} from './styled'
import { theme } from '../../../../styles/_variables'

const UNIT_OF_MEASURE = [{
  value: 1,
  text: 'เซนติเมตร (ซม.)',
  key: 'cm',
  label: 'ซม.',
}, {
  value: 2,
  text: 'นิ้ว',
  key: 'inches',
  label: 'นิ้ว',
}]

const UnitOfMeasure = ({
  data,
  onInputChange,
  isMobileXL,
}) => {
  const [unitOptions] = useState(UNIT_OF_MEASURE)
  return (
    <Content flexDirection='row' justifyContent='space-between' alignItems='baseline'>
      <Div display='flex' flexDirection='column' justifyContent='space-between' alignItems='flex-start'>
        <Label>หน่วยการวัด</Label>
      </Div>
      <Div display='flex' flexDirection='column' justifyContent='space-between' alignItems='flex-end'>
        <Select
          dropdown
          onChange={(e) => {
            onInputChange(unitOptions.find(v => v.value === e))
          }}
          style={{ width: isMobileXL ? '120px' : '180px', fontSize: theme.fonts.size.normal }}
          value={data.value}
        >
        {
          UNIT_OF_MEASURE.map(v => <Select.Option key={v.value} value={v.value}>{v.text}</Select.Option>)
        }
        </Select>
      </Div>
    </Content>
  )
}

export default UnitOfMeasure
